export default __webpack_public_path__ + "static/media/initial.c0bd39ff.svg";